<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        值班查岗
      </div>
    </div>

    <div class="common-page common-body">
      <div class="common-page common-tool-bar" v-hasPermi="['monitor:check:query']">
        <div class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>

        <!-- <router-link class="btn ml20" to="/device/device-add"><i class="icon-tr-newly-added"></i>新增</router-link> -->
      </div>
      <div class="">
        <el-table :data="list" class="">
          <el-table-column prop="c_number" label="单位编号" align="center"> </el-table-column>
          <el-table-column prop="device_code" label="设备编号" align="center"> </el-table-column>
          <el-table-column prop="c_type" label="单位类型" align="center">
            <template slot-scope="scope">
              {{ $map.unitType[scope.row.c_type] }}
            </template>
          </el-table-column>
          <el-table-column prop="c_name" label="单位名称" align="center"> </el-table-column>
          <el-table-column prop="c_address" align="center" label="地址"> </el-table-column>
          <el-table-column prop="c_phone" align="center" label="联系电话"> </el-table-column>

          <el-table-column prop="status" align="center" label="状态">
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column prop="progress" align="center" label="查岗结果"> </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope" v-hasPermi="['monitor:check:sendcheck']">
              <el-button type="primary" v-if="!scope.row.timmer" size="mini" @click="check(scope.row, scope.$index)">查岗</el-button>
              <span v-else-if="scope.row.timmer">{{ `剩余${timmerCount(scope.row.device_code)}秒` }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" :page-size="params.limit || 10" @current-change="pageChange" :total="total"> </el-pagination>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="resetSearch" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-backtop target=".common-body-style"></el-backtop>
  </div>
</template>
<script>
import { getCheckList, changeState, checkStates, editDevice, guard } from '../../api/device';

import db from '@/utils/localstorage';
export default {
  data() {
    return {
      list: [],
      params: { page: 1, limit: 10, c_name: '' },
      total: 0,
      showDia: false,
      searchForm: this.$getForm('deviceSearch'),
      editData: {},
      remoteFuncs: {},
      result: [],
      countList: this.$local.get('countList') || [],
      selectedNum: 0,
    };
  },
  components: {},
  created() {
    this.getList();
    //  changeState({updatestate:2,device_code:'111'})
    //  changeState({updatestate:2,device_code:'1122121'})
    //  changeState({updatestate:2,device_code:'1234577789'})
  },
  beforeDestroy() {
    //   this.stoped()
  },
  mounted() {},
  computed: {
    timmerCount() {
      return function(code) {
        var idx = 0;
        console.log(this.countList,code);
        this.countList.map((item, index) => {
          if (item.code == code) {
            idx = index;
          }
        });
        return this.countList[idx].time;
      };
    },
  },
  methods: {
    stoped() {
      this.list.map((item) => {
        item.timmer = false;
      });
    },
    isOk(code, index) {
      var changeData = (obj, title, bol, clearinter) => {
        obj.progress = title;
        obj.timmer = bol;
        this.list.splice(index, 1, obj);
        if (clearinter) clearInterval(gettimer);
        if (!bol && this.selectedNum >= 0) this.selectedNum--;
      };
      var obj = this.list[index];
      changeData(obj, '查岗中', true);
      //   var second=0;
      //   var cout = 0
      var gettimer = setInterval(() => {
        // second+=5
        if (!this.list[index].timmer) {
          clearInterval(gettimer);
          // second=0
          return false;
        }
        //  if(second==600){
        //        var dat = {updatestate:2,device_code:code}
        //           changeState(dat).then((Res)=>{
        //               changeData(obj,"应答失败",false)
        //               cout=0
        //           })
        //      return
        // }
        var data = [code];
        checkStates(data).then((res) => {
          //   cout++
          //   if(cout==120){
          //       var dat = {updatestate:2,device_code:code}
          //       changeState(dat).then((Res)=>{
          //           changeData(obj,"应答失败",false)
          //           cout=0
          //       })

          //   }
          var state = res.data.data[0].states;
          //   console.log(state)
          if (state == 1) {
            changeData(obj, '应答成功', false, true);
          } else if (!state) {
            changeData(obj, '应答失败', false, true);
          }
        });
      }, 5000);
    },

    timeDown(code, index, status) {
      //设备编号级list索引
      // console.log(code+','+index)

      if (this.countList.length) {
        //   console.log(this.countList)
        for (var i = 0; i < this.countList.length; i++) {
          if (this.countList[i].code == code) {
            // console.log(this.countList)
            console.log('有次数据 准备计时')
            var second = this.countList[i].time;
            var timmer = setInterval(() => {
              second--;
              // console.log(this.list[index].timmer)
              if (second == 0 || this.list[index].timmer == false) {
                console.log('准备清除数据，关闭定时')
                this.countList.map((item, idx) => {
                  if (item.code == code) {
                    this.countList.splice(idx, 1);
                    clearInterval(timmer);
                  }
                });
                this.list[index].timmer = false;
                // var dat = {updatestate:2,device_code:this.list[index].device_code}
                // changeState(dat)
                // console.log(this.countList)
                this.$local.save('countList', this.countList);
                if (second == 0) {
                  changeState({ updatestate: 2, device_code: code });
                  this.list[index].progress = '应答失败';
                }

                return;
              }

              this.countList.map((item) => {
                if (item.code == code) {
                  item.time = second;
                }
              });
              this.$local.save('countList', this.countList);
            }, 1000);
            return;
          }
        }
        //    console.log('没有这一条，添加一条')
        this.countList.push({ code, time: 600 });
        this.timeDown(code, index);
      } else {
        //   console.log("数组一条都没有，添加一条")
        this.countList.push({ code, time: 600 });
        this.timeDown(code, index);
      }
      // console.log(this.countList)
    },
    check(it, index) {
      this.$confirm('确定查岗此设备', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          //   console.log(it.device_code)
          var data = { robitid: it.device_code };
          if (this.selectedNum < 5) {
            this.selectedNum++;
            guard(data).then((res) => {
              if (res.code == 200) {
                //   checkStates([it.device_code]).then(rea=>console.log(rea))
                this.isOk(it.device_code, index);
                this.$message({
                  type: 'success',
                  message: '查岗成功!',
                });
                this.timeDown(it.device_code, index);
              }
            });
          } else {
            this.$message({
              type: 'warning',
              message: '最多查岗5台设备!',
            });
            this.selectedNum = 5;
          }
        })
        .catch(() => {});
    },

    // changeStatus(id, status) {
    //     editDevice({ id: id, status: status }).then(res => {
    //         this.getList()
    //     }).catch(err => {

    //     })
    // },
    getList() {
      getCheckList(this.params)
        .then((res) => {
          this.total = res.data.count;
          this.list = res.data.list;
          var arr = [];
          var statearr = []; //

          this.list.map((item, index) => {
            arr.push(item.device_code);
            item.progress = '待查岗';
          });

          checkStates(arr).then((msg) => {
            statearr = msg.data.data;
            // console.log(statearr)
            statearr.map((item, index) => {
              this.list.map((ite, idx) => {
                if (item.device_code === ite.device_code) {
                  var obj = this.list[idx];
                  var timmer = false;
                  var progress = '';
                  var state = item.states;
                  // console.log(226+state)
                  switch (state) {
                    case 2:
                      timmer = true;
                      progress = '查岗中';
                      this.selectedNum++;
                      this.timeDown(ite.device_code, idx);
                      this.isOk(item.device_code, idx);
                      break;
                    case 0:
                      progress = '应答失败';
                      break;
                    case 1:
                      progress = '应答成功';
                      break;
                    default:
                      progress = '待查岗';
                  }
                  obj.progress = progress;
                  obj.timmer = timmer;
                  this.list.splice(idx, 1, obj);
                }
              });
            });
          });
        })
        .catch((err) => {});
    },

    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.showDia = false;
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>
<style scoped></style>
